import { render, staticRenderFns } from "./EnterEmail.vue?vue&type=template&id=3985586d&scoped=true"
import script from "./EnterEmail.vue?vue&type=script&lang=js"
export * from "./EnterEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3985586d",
  null
  
)

export default component.exports